module.exports = __webpack_public_path__ + "img/logo-headline65x400.522b5f08.png";